<div class="m-subheader">
  <div class="mr-auto">
    <h3 class="m-subheader__title">
      {{ 'sales.statistics.abc-analysis' | transloco }}
    </h3>
    <span></span>
    <hx-date-range-select [onlyPastDates]="true" class="date-align" [(ngModel)]="params.date" (selectChange)="applyFilters()"></hx-date-range-select>
  </div>
</div>


<div class="m-content">
  <div class="row">
    <div class="col-sm-12">
      <div class="m-portlet m-portlet--full-height">
        <div class="m-portlet__body">
          <div class="hx-filters">
            <div class="filter">
              <hx-store-select [(ngModel)]="params.storeId" (selectChange)="onStoreChanged($event)"></hx-store-select>
            </div>
            <div class="filter">
              <hx-product-category-select [(ngModel)]="params.categoryId" [brandId]="1" (selectChange)="onCategoryChanged($event)"></hx-product-category-select>
            </div>
          </div>
          <div class="m_datatable m-datatable--va-top m-datatable m-datatable--default m-datatable--loaded m--margin-top-30 m--margin-bottom-30 block-table-scroll">
            <table class="m-datatable__table" *ngIf="sales.length && !isloading.sales">
              <thead class="m-datatable__head">
              <tr class="m-datatable__row m-datatable__row--head">
                <th class="m-datatable__cell">
                  <span>{{ 'sales.table.product' | transloco }}</span>
                </th>

                <th class="m-datatable__cell">
                  <span>{{ 'sales.table.sales' | transloco }}</span>
                </th>

                <th class="m-datatable__cell">
                  <span>{{ 'sales.table.sales-percent' | transloco }}</span>
                </th>

                <th class="m-datatable__cell">
                  <span>{{ 'sales.table.total' | transloco }}</span>
                </th>

                <th class="m-datatable__cell">
                  <span>{{ 'sales.table.total-percent' | transloco }}</span>
                </th>

                <th class="m-datatable__cell">
                  <span>{{ 'sales.table.profit' | transloco }}</span>
                </th>

                <th class="m-datatable__cell">
                  <span>{{ 'sales.table.profit-percent' | transloco }}</span>
                </th>

                <th class="m-datatable__cell">
                  <span>{{ 'sales.table.sales' | transloco }}</span>
                </th>

                <th class="m-datatable__cell">
                  <span>{{ 'sales.table.total' | transloco }}</span>
                </th>

                <th class="m-datatable__cell">
                  <span>{{ 'sales.table.profit' | transloco }}</span>
                </th>
              </tr>
              </thead>
              <tbody class="m-datatable__body">
              <tr *ngFor="let even = even; let i = index; let item of sales"
                  class="m-datatable__row" [ngClass]="{ 'm-datatable__row--even': even }">
                <td class="m-datatable__cell">
                  <a *ngIf="item.productInfoTitle" [title]="item.productInfoTitle | uiLabel" [routerLink]="['../product-sales/abc-analysis']" [queryParams]="{dateFrom: params.date?.from, dateTo: params.date?.to, productInfoId: item.productInfoId, productTitle: item.productInfoTitle | uiLabel }">
                    {{ item.productInfoTitle | uiLabel }}
                  </a>
                </td>

                <td class="m-datatable__cell">
                  {{ item.totalAmount }} {{ 'sales.piece-short' | transloco }}
                </td>

                <td class="m-datatable__cell min-width-100">
                  {{ item.totalAmountPercent }} %
                </td>

                <td class="m-datatable__cell min-width-100">
                  {{ item.totalValue | moneyFormat | uiCurrency: item.currency }}
                </td>

                <td class="m-datatable__cell min-width-100">
                  {{ item.totalValuePercent }} %
                </td>

                <td class="m-datatable__cell min-width-100">
                  {{ item.totalCostPrice | moneyFormat | uiCurrency: item.currency }}
                </td>

                <td class="m-datatable__cell min-width-100">
                  {{ item.totalCostPricePercent }} %
                </td>

                <td class="m-datatable__cell min-width-100" [ngClass]="{ 'abc-a-analysis': item.abcAmountGroup === 'A',
                    'abc-b-analysis': item.abcAmountGroup === 'B',
                    'abc-c-analysis': item.abcAmountGroup === 'C' }">
                  {{ item.abcAmountGroup }}
                </td>

                <td class="m-datatable__cell min-width-100" [ngClass]="{ 'abc-a-analysis': item.abcValueGroup === 'A',
                    'abc-b-analysis': item.abcValueGroup === 'B',
                    'abc-c-analysis': item.abcValueGroup === 'C' }">
                  {{ item.abcValueGroup }}
                </td>

                <td class="m-datatable__cell min-width-100" [ngClass]="{ 'abc-a-analysis': item.abcCostPriceGroup === 'A',
                    'abc-b-analysis': item.abcCostPriceGroup === 'B',
                    'abc-c-analysis': item.abcCostPriceGroup === 'C' }">
                  {{ item.abcCostPriceGroup }}
                </td>

              </tr>
              </tbody>
            </table>

            <hx-loader [length]="sales.length" [isLoading]="isloading.sales"></hx-loader>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
